import {FormattedMessage} from "react-intl";

export const dayToString = (date) => {

    switch (date.getDay()) {
        case 0: return <FormattedMessage id={'common.dayOfWeek.Sunday'}></FormattedMessage>
        case 1: return <FormattedMessage id={'common.dayOfWeek.Monday'}></FormattedMessage>
        case 2: return <FormattedMessage id={'common.dayOfWeek.Tuesday'}></FormattedMessage>
        case 3: return <FormattedMessage id={'common.dayOfWeek.Wednesday'}></FormattedMessage>
        case 4: return <FormattedMessage id={'common.dayOfWeek.Thursday'}></FormattedMessage>
        case 5: return <FormattedMessage id={'common.dayOfWeek.Friday'}></FormattedMessage>
        case 6: return <FormattedMessage id={'common.dayOfWeek.Saturday'}></FormattedMessage>

    }
}